import React from 'react';
import { Grid } from 'semantic-ui-react';
import POSButton from './../../common/component/Button';
import 'PointOfSale/styles/components/pageHeader.less';
import PropTypes from 'prop-types';

import {
  SessionTypes,
  SessionTypeDetails,
} from 'PointOfSale/modules/common/constants';

const SessionChipsComponent = props => {
  const {
    queueButtonClick,
    teacherButtonClick,
    sessions,
    currentSelectedSession,
  } = props;
  return (
    <div>
      <Grid container className="margin0">
        <Grid.Row columns={2} textAlign="center">
          <Grid.Column>
            <POSButton
              key="queue"
              label={SessionTypeDetails[SessionTypes.Queue].label}
              disabled={sessions[SessionTypes.Queue] !== undefined}
              onClick={queueButtonClick}
              selected={currentSelectedSession === SessionTypes.Queue}
            />
          </Grid.Column>
          <Grid.Column>
            <POSButton
              key="teacher"
              label={SessionTypeDetails[SessionTypes.Teacher].label}
              disabled={sessions[SessionTypes.Teacher] !== undefined}
              onClick={teacherButtonClick}
              selected={currentSelectedSession === SessionTypes.Teacher}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={2} textAlign="center">
          {/* <Grid.Column>
          <POSButton
            key="group"
            label={SessionTypeDetails[SessionTypes.Group].label}
            disabled={sessions[SessionTypes.Group] !== undefined}
            onClick={groupButtonClick}
            selected={currentSelectedSession === SessionTypes.Group}
          />
        </Grid.Column> */}
        </Grid.Row>
      </Grid>
    </div>
  );
};

SessionChipsComponent.propTypes = {
  queueButtonClick: PropTypes.func,
  groupButtonClick: PropTypes.func,
  teacherButtonClick: PropTypes.func,
  otherItemButtonClick: PropTypes.func,
  sessions: PropTypes.object,
  currentSelectedSession: PropTypes.string,
};

export default SessionChipsComponent;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/servingOptions/component/SessionChips.js